import { render, staticRenderFns } from "./AllocatedBackorderHistoryEtaGrid.vue?vue&type=template&id=5050480f&"
import script from "./AllocatedBackorderHistoryEtaGrid.vue?vue&type=script&lang=js&"
export * from "./AllocatedBackorderHistoryEtaGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports